import React from 'react';
import { Radio } from 'antd';

interface YesNoRadioProps {
  value?: number;
  onChange?: (value: number) => void;
}

/**
 * 是否选择单选框组件
 */
const YesNoRadio: React.FC<YesNoRadioProps> = ({ value, onChange }) => {
  return (
    <Radio.Group value={value} onChange={(e) => onChange?.(e.target.value)}>
      <Radio value={0}>否</Radio>
      <Radio value={1}>是</Radio>
    </Radio.Group>
  );
};

export default YesNoRadio;

